import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/landing.css';

const LandingPage = () => {
  const navigate = useNavigate();

  const features = [
    {
      icon: 'fas fa-laptop-code',
      title: 'Build Real Digital Products',
      description: 'GRIT Lab Africa trains young Africans to build real applications, games, AI tools, VR/AR experiences, and digital platforms that solve practical problems.',
      image: '/4ir-training.png'
    },
    {
      icon: 'fas fa-tools',
      title: 'Learn by Building',
      description: 'Our students do not only attend classes. They build, test, improve, present, and showcase real solutions through project-based learning.',
      image: '/hands-on.png'
    },
    {
      icon: 'fas fa-briefcase',
      title: 'Train for the Future of Work',
      description: 'We prepare African youth for software development, AI, digital innovation, entrepreneurship, and emerging technology opportunities.',
      image: '/employment.png'
    },
    {
      icon: 'fas fa-user-tie',
      title: 'Grow with Mentorship',
      description: 'GRITers receive guidance from experienced academics, developers, innovators, industry experts, and alumni who understand both learning and real-world delivery.',
      image: '/mentorship.png'
    },
    {
      icon: 'fas fa-globe-africa',
      title: 'Join a Pan-African Innovation Family',
      description: 'GRIT Lab Africa connects students across African universities into a powerful community of builders, problem-solvers, and future technology leaders.',
      image: '/community.png'
    },
    {
      icon: 'fas fa-bullseye',
      title: 'Create Impact Through Technology',
      description: 'Our work turns talent into solutions, ideas into products, and learning into measurable social and economic impact.',
      image: '/industry.png'
    }
  ];

  return (
    <div className="landing-page">
      {/* Hero Section */}
      <div className="hero">
        <div className="hero-content">
          <h1>Welcome to the Future at GRIT Lab Africa</h1>
          <p>Your journey as a technology builder and problem solver starts here. Access your lessons, complete hands-on projects, track your progress, and grow from a learner into a confident digital innovator.</p>
          <p style={{ marginTop: '1rem', color: '#666' }}>This platform supports your GRIT Lab Africa bootcamp experience, helping you build real skills, real products, and real solutions for Africa’s future.</p>
          <div className="hero-buttons">
            <button className="btn btn-dark" onClick={() => navigate('/login')}>
              Begin Your Journey
            </button>
            <button className="btn btn-text" onClick={() => navigate('/login')}>
              <i className="fas fa-arrow-right" style={{ marginRight: '0.5rem' }}></i>
              Welcome Back
            </button>
          </div>
        </div>
        <div className="hero-image-container">
          <div className="hero-image">
            <img 
              src="/hero.jpg" 
              alt="Online Learning Platform"
              style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '12px', display: 'block' }}
            />
          </div>
        </div>
      </div>

      {/* Features Section */}
      <section className="features-section">
        <h2>About Grit Lab Africa</h2>
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <img 
                src={feature.image} 
                alt={feature.title}
                style={{ width: '100%', height: '200px', objectFit: 'cover', borderRadius: '8px', marginBottom: 'var(--spacing-lg)' }}
              />
              <h3>
                <i className={feature.icon} style={{ color: '#1a1a1a', marginRight: '0.5rem' }}></i>
                {feature.title}
              </h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default LandingPage;
